import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import gsap from "gsap";

export default class Text {
	constructor(experience, position, text, { size = 0.08, y = -1.4, id = 5 } = {}) {
		this.experience = experience;
		this.scene = this.experience.scene;

		const loader = new FontLoader();
		loader.load("/fonts/Apoc.json", (font) => {
			const geometry = new TextGeometry(text, {
				font: font,
				size,
				height: 0.4,
				depth: 0,
			});

			const material = new THREE.MeshBasicMaterial({
				color: 0x000000,
				transparent: true,
				opacity: 0,
			});

			const mesh = new THREE.Mesh(geometry, material);
			mesh.position.set(position - 7, y, 0);
			this.mesh = mesh;
			this.scene.add(mesh);

			gsap.to(mesh.material, {
				opacity: 1,
				duration: 2,
				ease: "power4.out",
				delay: 2.5 + 0.3 + id * 0.1,
			});
		});
	}
}
